import { NAVIGATION_HEIGHT } from "../../constants/global";
import { styled } from "../stitches.config";

export const LessonPageShell = styled('div', {
    background: '#f0f2f5',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    paddingTop: `calc(${NAVIGATION_HEIGHT} + 1rem)`,
    paddingLeft: '1rem',
    paddingRight: '1rem',
    paddingBottom: '1rem',


});

export const LessonPageWrapper = styled('div', {
    display: 'grid',
    gridTemplateRows: 'auto 1fr', // For header and scrollable content
    width: '100%',
    height: '100%',
    boxShadow: '0 6px 24px rgba(0,0,0,0.08)',
    borderRadius: '16px',
    background: 'white',
    overflow: 'hidden', // Ensures children respect the border radius
});

export const LessonPageContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    background: 'transparent',
    height: '100%', // Fill the entire height of the <Area>
});

// Note: LessonArea is no longer needed.

export const MainContentArea = styled('div', {
    overflowY: 'auto', // This makes the content scrollable
    overflowX: 'hidden',
    flex: 1,           // ✅ Takes up all available remaining space
    minHeight: 0, 
    padding: '1.5rem', // More generous padding for the content itself
});

export const Header = styled('div', {
    height: '3.5rem',
    padding: '0 1.5rem', // Horizontal padding for header content
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBottom: '1px solid $elementBorder',
    background: '$blueWeeks',
    fontSize: '$md',
    fontWeight: 600,
    color: '$sand12',
});



export const HeaderContainer = styled('div', {
    display: 'grid',
    height: '3.5rem',
    background: '$blueWeeks',
    gridTemplateColumns: '1fr 1fr 1fr', // Three equal columns
});